import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const IEInput = forwardRef((props, ref) => (
  <InputTemplate {...props} formato="###.###.###.###.###" ref={ref} />
));

export default IEInput;
